import {API_HOST_NAME} from "../../constants.js";
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js";

const useServicePortMappingsResources = (teamId, projectId, serviceId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/projects/${projectId}/services/${serviceId}/port_mappings`;
  return useAuthenticatedResources(url)
}

export default useServicePortMappingsResources;
